import { render, staticRenderFns } from "./other-info.vue?vue&type=template&id=1ff2fdbf&"
import script from "./other-info.vue?vue&type=script&lang=js&"
export * from "./other-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports